import type { GambleStep } from "@slot/game-shell";

export const step02Win: GambleStep = {
  outcome: "win",
  multiplier: "2",
  serverChosenValue: "black",
  // base post-bet balance 100000 + newWin 800
  balanceAmountMinor: "100800",
};
